﻿import "bootstrap";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

interface AuftragnehmerResponse {
    email: string;
    // add other properties if needed
}
export class GuiDetailBestellung extends GuiDetailGeneric {
    constructor() {
        super("Bestellung");
    }

    override attachEvents() {
        super.attachEvents();

        $("#btnBestellungAktionChoose").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickBestellungAktionChoose(e));
        $("#btnBestellungAdbChoose").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickBestellungAdbChoose(e));

        $("#btnSendBestellung").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickSendBestellung(e));
        $("#btnSendAval").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickSendAval(e));

        $("#VmDetail_AuftragnehmerId").on("change", (e: JQuery.ChangeEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.changeAuftragnehmer(e));
    }

    //override
    override clickDetailRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickDetailRow");

        const ele = $(e.currentTarget);
        const head = ele.closest("div.erz-detail-list");
        const baseurl = head.data("url-detail") as string; // goto url im Kopf

        const id = $(e.currentTarget).closest("div.erz-list-element").data("id") as string | number;
        const bestellungId = $("#VmDetail_BestellungId").val() as string;

        const url = `${baseurl}?id=${id}&bestellungId=${bestellungId}`;
        this.gotoUrl(url);
    }


    clickSendBestellung(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickSendBestellung");
        e.preventDefault();
        $("#mdlBestellungEmail").modal("show");
    }

    clickSendAval(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickSendAval");
        this.doAction(e);
    }

    clickBestellungAktionChoose(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickBestellungAktionChoose");
        this.doAction(e);
    }

    clickBestellungAdbChoose(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickBestellungAdbChoose");
        this.doAction(e);
    }

    changeAuftragnehmer(e: JQuery.ChangeEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {

        const id = $(e.currentTarget).val() as string;
        if (id === "" || id === undefined) return;

        const endpointUrl = $("#VmDetail_AuftragnehmerId").data("url") as string;
        const url = `${endpointUrl}?auftragnehmerId=${id}`;

        ////const token = $('[name=__RequestVerificationToken]').val();
        ////AppLog.logInfo(`securityToken:${token}`);
        $.ajax({
            type: "GET",
            url: url,
            contentType: "application/json; charset=utf-8",
        }).done((data: AuftragnehmerResponse) => {
            $("#VmDetail_NeuerVersandAn").val(data.email);
        });
    }
}

